/*
This file is located in the main branch
Last time the file was updated (UTC): [02.07.2024 18:52:59]
Permissions to update outside the main branch: [false]
*/

import { Filter, Input, toInt, useGridFilterUrlContext } from '@finbeat/react-toolkit';
import { DeclinedShowcase } from 'models/api/declinedShowcase';
import { useTranslation } from 'react-i18next';

const DeclinedShowcasesFilter = () => {
    const { draftFilter, setDraftFilter } = useGridFilterUrlContext<Filter<DeclinedShowcase>>();
    const { t } = useTranslation();

    return (
        <Input
            type="number"
            id="b-filter-id"
            value={draftFilter.id || ''}
            onChange={(e) => {
                setDraftFilter((prevState) => ({
                    ...prevState,
                    id: toInt(e.target.value),
                }));
            }}
            label={t('BackOfficeId')}
        />
    );
};

export default DeclinedShowcasesFilter;
